
import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"

function AllFinance() {
          const { currentLocal } = useSelector((state) => state.currentLocal);
              const [items, setItems] = useState([{
                id:0,description:"تم تصليح الباب",date:"17/8/2025",price:"10000",employee:"أحمد",phone:"01021053778",status:"قسم الصيانة"
              },
            {
                id:1,description:"تم شراء ورق",price:"15000",date:"17/8/2025",employee:"أحمد",phone:"01021053778",status:"قسم مشتريات"
              },
              {
                id:2,description:"تم تصليح الحاسب الالي",price:"20000",date:"17/8/2025",employee:"أحمد",phone:"01021053778",status:"قسم الصيانة"
              }
            ])

    const headerIterm = [
        currentLocal.home.ID,
        currentLocal.home.description,
        currentLocal.home.price,
                currentLocal.home.date,
                currentLocal.home.employee,
                currentLocal.home.section,

                currentLocal.home.phone,

        

   ]
  return (
    <div className="px-0 my-3 w-100 dashboard_content">
    <Container>
        <div className="d-flex flex-column w-100">
            
            <AuthNavbar />
            <div className="mt-5 mx-3">
                <HomeTitle title={currentLocal.home.AllFinance} />
            

            <p className="w-100 mb-5 fw-bold"> {currentLocal.home.AllFinance}:150</p>


                <Table
                    data={items}
                    headerIterm={headerIterm}
                    // onDataChanged={getAllApis}
                />


            </div>

        </div>
    </Container>
</div>)
}

export default AllFinance